import { RouteObject, Navigate, useParams, useLocation } from "react-router-dom";
import SupportPage from "@/pages/support/page";
import MyRequestsPage from "@/pages/my-requests/page";
import HomePage from "../pages/home/page";
import CategoriesPage from "../pages/categories/page";
import ProductDetailPage from "../pages/product/page";
import LoginPage from "../pages/login/page";
import RegisterPage from "../pages/register/page";
import AdminPage from "../pages/admin/page";
import CompaniesPage from "../pages/companies/page";
import CompanyDetailPage from "../pages/company/page";
import KoreanBriefPage from "../pages/korean-brief/page";
import KoreanBriefDetailPage from "../pages/korean-brief/detail";
import AssociationPage from "../pages/association/page";
import AssociationDetailPage from "../pages/association/detail";
import EventsPage from "../pages/events/page";
import EventDetailPage from "../pages/events/detail";
import ActivitiesPage from "../pages/activities/page";
import CatalogPage from "@/pages/catalog/page";
import TechCooperationPage from "../pages/tech-cooperation/page";
import TechCooperationDetailPage from "../pages/tech-cooperation/detail";
import FlipbookPage from "@/pages/flipbook/page";
import NotFoundPage from "../pages/NotFound";
import GreetingPage from "../pages/introduction/greeting";
import OverviewPage from "../pages/introduction/overview";

// ── Legacy redirect wrappers (read params then redirect) ─────────────
function CompanyRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/doanh-nghiep/${id}`} replace />;
}
function AssociationRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/hoat-dong-hiep-hoi-va-su-kien/${id}`} replace />;
}
function EventRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/su-kien/${id}`} replace />;
}
/** Legacy /products/:slug → redirect to new product page */
function OldProductRedirect() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();
  // Try to reconstruct company+product slug from existing state (best effort)
  // Fallback: redirect to homepage with product slug as search
  return <Navigate to={`/?q=${encodeURIComponent(slug ?? "")}`} replace />;
}
/** Legacy /san-pham/:slug → redirect to new URL */
function LegacySanPhamRedirect() {
  const { slug } = useParams<{ slug: string }>();
  // Just redirect to search since we can't reconstruct company slug
  return <Navigate to={`/?q=${encodeURIComponent(slug ?? "")}`} replace />;
}
/** Legacy /catalog/:id → redirect to search */
function LegacyCatalogRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/?q=${encodeURIComponent(id ?? "")}`} replace />;
}

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },

  // ── Introduction pages ──────────────────────────────────────────────
  { path: "/loi-chao", element: <GreetingPage /> },
  { path: "/khai-quat-cong-ty", element: <OverviewPage /> },

  // ── New localized paths ───────────────────────────────────────────────
  { path: "/danh-muc", element: <CategoriesPage /> },
  { path: "/danh-muc/:categoryId", element: <CategoriesPage /> },
  { path: "/san-pham/:slug", element: <LegacySanPhamRedirect /> },
  // New structure: /{company-slug}/{product-slug}
  { path: "/:companySlug/:productSlug", element: <ProductDetailPage /> },
  { path: "/doanh-nghiep", element: <CompaniesPage /> },
  { path: "/doanh-nghiep/:id", element: <CompanyDetailPage /> },
  { path: "/hoat-dong-hiep-hoi-va-su-kien", element: <ActivitiesPage /> },
  { path: "/hoat-dong-hiep-hoi-va-su-kien/:id", element: <AssociationDetailPage /> },
  { path: "/su-kien", element: <EventsPage /> },
  { path: "/su-kien/:id", element: <EventDetailPage /> },
  { path: "/korean-brief", element: <KoreanBriefPage /> },
  { path: "/korean-brief/:id", element: <KoreanBriefDetailPage /> },
  { path: "/hop-tac-ky-thuat", element: <TechCooperationPage /> },
  { path: "/hop-tac-ky-thuat/:id", element: <TechCooperationDetailPage /> },
  { path: "/tra-cuu-tu-van", element: <MyRequestsPage /> },
  { path: "/support/:slug", element: <SupportPage /> },
  // Catalog (new structure: /chi-tiet/{vendor}/{product})
  { path: "/chi-tiet/:companySlug/:productSlug", element: <CatalogPage /> },
  // Flipbook (new structure: /flipbook/catalog/{vendor}/{product})
  { path: "/flipbook/catalog/:companySlug/:productSlug", element: <FlipbookPage /> },
  // Legacy catalog redirect
  { path: "/catalog/:id", element: <LegacyCatalogRedirect /> },

  // Auth
  { path: "/login", element: <LoginPage /> },
  { path: "/register", element: <RegisterPage /> },

  // Admin
  { path: "/admin", element: <AdminPage /> },

  // ── Legacy redirects (301) ────────────────────────────────────────────
  { path: "/categories", element: <Navigate to="/danh-muc" replace /> },
  { path: "/categories/*", element: <Navigate to="/danh-muc" replace /> },
  { path: "/products/:slug", element: <OldProductRedirect /> },
  { path: "/companies", element: <Navigate to="/doanh-nghiep" replace /> },
  { path: "/company/:id", element: <CompanyRedirect /> },
  { path: "/activities", element: <Navigate to="/hoat-dong-hiep-hoi-va-su-kien" replace /> },
  { path: "/association/:id", element: <AssociationRedirect /> },
  { path: "/events", element: <Navigate to="/su-kien" replace /> },
  { path: "/events/:id", element: <EventRedirect /> },
  { path: "/my-requests", element: <Navigate to="/tra-cuu-tu-van" replace /> },

  // Legacy alias (kept)
  { path: "/korea-brief", element: <KoreanBriefPage /> },

  // 404
  { path: "*", element: <NotFoundPage /> },
];

export default routes;
